import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/Home.vue")
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("../views/Home.vue")
  },
  //pagina para nueva pagina, crear cuenta
  // no esta autenticados aun.
  {
    path: "/signup",
    name: "signup",
    component: () => import("../views/Signup.vue")
  },
  // here we catch all fisrt level paremeter
  {
    path: "/:param0",
    name: "module",
    component: () => import("../views/PainterViewer.vue")
  },
  // here we catch all fisrt level paremeter
  {
    path: "/:param0/:param1",
    name: "modulePage",
    component: () => import("../views/PainterViewer.vue")
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})

export default router
